import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconBeachAccess, IconLocationCity, IconFlight, IconDownhillSkiing } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { AttributesContainer } from '../../../../../../components/HotelDetailsOverlay/components/DescriptionSection/components/DistancesSection/components/AttributesContainer.js';
import { Container } from '../../../../../../components/HotelDetailsOverlay/components/DescriptionSection/components/DistancesSection/components/Container.js';
import { DistanceItem } from '../../../../../../components/HotelDetailsOverlay/components/DescriptionSection/components/DistancesSection/components/DistanceItem.js';
import { HeadlineSmall, HelpTooltip, Flex } from '../../../../../../primitives/index.js';
import { SPACING_MEDIUM } from '../../../../../../utils/spacingLegacy.js';
const DISTANCE_CONFIG = [{
  type: 'beach',
  icon: IconBeachAccess
}, {
  type: 'city',
  icon: IconLocationCity
}, {
  type: 'airport',
  icon: IconFlight
}, {
  type: 'ski',
  icon: IconDownhillSkiing
}];
export const DistancesSection = ({
  distances
}) => {
  const {
    t
  } = useTranslation();
  if (!distances) {
    return null;
  }
  return _jsxs(Container, {
    spacing: SPACING_MEDIUM,
    children: [_jsxs(Flex, {
      direction: "row",
      spacing: "4px",
      children: [_jsx(HeadlineSmall, {
        children: t('hotelDetailsOverlay:descriptionSection.distances.title')
      }), _jsx(HelpTooltip, {
        content: t('hotelDetailsOverlay:descriptionSection.distances.tooltip')
      })]
    }), _jsx(AttributesContainer, {
      children: DISTANCE_CONFIG.map(({
        type,
        icon: IconComponent
      }) => {
        const distance = distances[type];
        if (!distance) return null;
        return _jsx(DistanceItem, {
          icon: _jsx(IconComponent, {}),
          distance: distance.distance,
          label: `${t('hotelDetailsOverlay:descriptionSection.distances.to')} ${distance.label}`
        }, type);
      })
    })]
  });
};